import * as React from "react";
import { Pill, PillVariant, PillSize } from "azure-devops-ui/Pill";
import { PillGroup, PillGroupOverflow } from "azure-devops-ui/PillGroup";
import { IColor } from "azure-devops-ui/Utilities/Color";

export default class LargePill extends React.Component<{}> {
    public render() {
        return (
            <PillGroup className="flex-row" overflow={PillGroupOverflow.wrap}>
                <Pill size={PillSize.large}>C#</Pill>
                <Pill size={PillSize.large} variant={PillVariant.outlined}>
                    TypeScript
                </Pill>
                <Pill
                    color={this.darkColor}
                    size={PillSize.large}
                    variant={PillVariant.colored}
                    onClick={() => alert("MSSQL pill clicked!")}
                >
                    MSSQL
                </Pill>
                <Pill
                    iconProps={{ iconName: "Package" }}
                    onRemoveClick={this.removeHandler}
                    size={PillSize.large}
                >
                    Packages
                </Pill>
                <Pill
                    onRenderFilledVisual={this.renderFilledVisual}
                    size={PillSize.large}
                    variant={PillVariant.outlined}
                >
                    Filled Visual
                </Pill>
            </PillGroup>
        );
    }

    private darkColor: IColor = {
        red: 151,
        green: 30,
        blue: 79
    };

    private removeHandler = () => {
        alert("Parent should remove the pill");
    };

    // You can render anything you want here; however, it'll be forcibly cropped to fit the circular area
    private renderFilledVisual = () => {
        return <div style={{ width: "100%", height: "100%", backgroundColor: "#FBB7D2" }} />;
    };
}
